import { Controller } from "@hotwired/stimulus";
import { put } from "@rails/request.js";

export default class extends Controller {
  static targets = ["list", "tag"]
  static values = {
    url: String
  }

  async add(event){
    const inputValue = event.target.value;

    if(inputValue.length === 0) return;

    const container = document.createElement("div");
    container.classList.add("form__tag");

    const input = document.createElement("input");
    input.value = inputValue;
    input.name = "course[tag_list][]";
    input.type = "hidden";
    input.setAttribute("data-tags-target", "tag");

    const button = document.createElement("button");
    button.innerText = "x";
    button.setAttribute("data-action", "click->tags#remove:prevent");

    const p = document.createElement("p");
    p.innerText = inputValue;

    container.append(input);
    container.append(p);
    container.append(button);

    this.listTarget.append(container);
    event.target.value = "";

    await this.updateTagList();
  }

  async remove(event) {
    event.target.parentNode.remove();
    
    await this.updateTagList();
  }

  async updateTagList() {
    const tagsArr = this.tagTargets.map(t => t.value);

    await put(this.urlValue, {
      responseKind: "turbo-stream",
      body: {
        course: {
          tag_list: tagsArr,
        },
      },
    })
  }
}
